import { render, staticRenderFns } from "./companyIcon.vue?vue&type=template&id=5e74a2f1&scoped=true&"
import script from "./companyIcon.vue?vue&type=script&lang=js&"
export * from "./companyIcon.vue?vue&type=script&lang=js&"
import style0 from "./companyIcon.vue?vue&type=style&index=0&id=5e74a2f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e74a2f1",
  null
  
)

export default component.exports